<script lang="ts">
    
    import { FormGroup } from "sveltestrap";
    import type { State } from "../../Model/State";
    import ControlFeedback from "../ControlFeedback.svelte";
    import ControlLabel from "../ControlLabel.svelte";

    export let label: string;
    export let value: State<string>;
    export let required = false;

</script>

<FormGroup>
    <ControlFeedback
        let:invalid
        let:valid
        let:valueMissing
        let:input>

        <ControlLabel {required} invalid={input && invalid}>{label}</ControlLabel>

        <input type="text" class="form-control" bind:value={$value} {required} on:change>

        <slot {invalid} {valid} {valueMissing} {input} />

    </ControlFeedback>
</FormGroup>
